// extracted by mini-css-extract-plugin
module.exports = {"admin":"Admin_admin__2D6MP","brand":"Admin_brand__1zhtY","avatar":"Admin_avatar__3g3R8"};